import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation deactivateJiraServerMutation($input: DeactivateJiraServerInput!) {
		deactivateJiraServer(input: $input) {
			viewer {
				company {
					jiraServerPublicRsaKey
					jiraServerConsumerKey
					jiraServerUrl
					jiraServerAccessToken
					jiraServerEnabled
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId()}};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
